import {
  ErrorDefault,
  RequestDefault,
  ResponseDefault,
} from "../../shared/constant";
import invoiceConstants from "../constants/invoiceConstants";

const initialState: {
  invoices: any[];
  invoicesResponse: any;
  invoiceDetails: any;
  error: Boolean;
  pending: Boolean;
  fulfilled: Boolean;
  createInvoiceSuccess: Boolean;
  updateInvoiceSuccess: Boolean;
  sendInvoicePending: Boolean;
  sendInvoiceFulfilled: Boolean;
  invoicesPending: Boolean;
} = {
  invoices: [],
  invoicesResponse: null,
  invoiceDetails: null,
  error: false,
  pending: false,
  fulfilled: false,
  createInvoiceSuccess: false,
  updateInvoiceSuccess: false,
  sendInvoicePending: false,
  sendInvoiceFulfilled: false,
  invoicesPending: false,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case invoiceConstants.GET_INVOICES_REQUEST:
      return {
        ...state,
        invoicesPending: true,
      };
    case invoiceConstants.GET_INVOICES_SUCCESS:
      return {
        ...state,
        invoicesPending: false,
        invoices: action.payload.data.results,
        invoicesResponse: action.payload.data,
      };
    case invoiceConstants.GET_INVOICES_FAILURE:
      return {
        ...state,
        invoicesPending: false,
      };
    case invoiceConstants.GET_INVOICE_DETAILS_SUCCESS:
      return {
        ...state,
        invoiceDetails: action.payload.data,
      };
    case invoiceConstants.SEND_INVOICE_REQUEST:
      return {
        ...state,
        sendInvoicePending: true,
        sendInvoiceFulfilled: false,
      };
    case invoiceConstants.SEND_INVOICE_SUCCESS:
      return {
        ...state,
        sendInvoicePending: false,
        sendInvoiceFulfilled: true,
      };
    case invoiceConstants.SEND_INVOICE_FAILURE:
      return {
        ...state,
        sendInvoicePending: false,
        sendInvoiceFulfilled: false,
      };
    case invoiceConstants.CREATE_INVOICE_REQUEST:
      return {
        ...state,
        ...RequestDefault,
        createInvoiceSuccess: false,
      };
    case invoiceConstants.CREATE_INVOICE_SUCCESS:
      return {
        ...state,
        ...ResponseDefault,
        createInvoiceSuccess: true,
      };
    case invoiceConstants.CREATE_INVOICE_FAILURE:
      return {
        ...state,
        ...ErrorDefault,
        createInvoiceSuccess: false,
      };
    case invoiceConstants.UPDATE_INVOICE_SUCCESS:
      return {
        ...state,
        updateInvoiceSuccess: true,
      };
    case invoiceConstants.RESET_INVOICE_SENT:
      return {
        ...state,
        updateInvoiceSuccess: false,
        sendInvoicePending: false,
        sendInvoiceFulfilled: false,
      };
    case invoiceConstants.RESET_INVOICES:
      return {
        ...state,
        invoices: [],
        invoicesResponse: null,
        createInvoiceSuccess: false,
        updateInvoiceSuccess: false,
        invoiceDetails: null,
        sendInvoicePending: false,
        sendInvoiceFulfilled: false,
      };
    default:
      return {
        ...state,
      };
  }
};
